(function(){

  var STORAGE_KEY = 'cmr_wishlist_v1';
  var toastTimer = null;

  function getCurrentLanguage(){
    return (document.documentElement.lang || 'fr').toLowerCase();
  }

  function isEnglish(){
    return getCurrentLanguage().indexOf('en') === 0;
  }

  function t(fr, en){
    return isEnglish() ? en : fr;
  }

  function readWishlist(){
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch(e) {
      return [];
    }
  }

  function writeWishlist(items){
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function getProduct(button){

    var handle = button.getAttribute('data-product-handle');
    if (!handle) return null;

    function cleanText(value){
      return String(value || '')
        .replace(/\s+/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .trim();
    }

    function hasMoney(value){
      return /(\d|€|Ar|MGA)/i.test(cleanText(value));
    }

    var title = button.getAttribute('data-product-title') || '';
    var url = button.getAttribute('data-product-url') || '';
    var image = button.getAttribute('data-product-image') || '';
    var price = cleanText(
      button.getAttribute('data-product-price') || ''
    );
    var comparePrice = cleanText(
      button.getAttribute('data-product-compare-price') || ''
    );

    var card = button.closest(
      '.cmr-new-products__card, ' +
      '.cmr-best-sales__card, ' +
      '.cmr-promotions__card, ' +
      '.cmr-home-search-card, ' +
      '.cmr-related-products__card, ' +
      '.cmr-you-may-like__card, ' +
      'article, li, .grid__item, .card-wrapper, ' +
      '.product-card, .product-item, .card, .swiper-slide'
    );

    if (card) {

      if (!price) {
        var priceEl = card.querySelector(
          '.cmr-new-products__price, ' +
          '.cmr-best-sales__price, ' +
          '.cmr-promotions__price, ' +
          '.cmr-home-search-card__price, ' +
          '.price-item--sale, .price__sale'
        );

        if (priceEl && hasMoney(priceEl.textContent)) {
          price = cleanText(priceEl.textContent);
        }
      }

      if (!comparePrice) {
        var compareEl = card.querySelector(
          '.cmr-new-products__compare-price, ' +
          '.cmr-best-sales__compare-price, ' +
          '.cmr-promotions__compare-price, ' +
          '.cmr-home-search-card__price-compare, ' +
          '.cmr-related-products__compare-price, ' +
          '.cmr-you-may-like__compare-price, ' +
          '.price__compare, ' +
          '.price-item--regular, ' +
          '.compare-price, ' +
          '.product-card__compare-price, ' +
          's, del'
        );

        if (compareEl && hasMoney(compareEl.textContent)) {
          comparePrice = cleanText(compareEl.textContent);
        }
      }
    }

    return {
      handle: handle,
      title: title,
      url: url,
      image: image,
      price: price,
      comparePrice: comparePrice,
      addedAt: Date.now()
    };
  }

  function exists(handle){
    return readWishlist().some(function(item){
      return item.handle === handle;
    });
  }

  function add(product){

    var items = readWishlist();
    var existingIndex = -1;

    items.some(function(item, index){
      if (item.handle === product.handle) {
        existingIndex = index;
        return true;
      }
      return false;
    });

    if (existingIndex === -1) {

      items.unshift(product);

    } else {

      items[existingIndex] = {
        handle: items[existingIndex].handle || product.handle,
        title: product.title || items[existingIndex].title || '',
        url: product.url || items[existingIndex].url || '',
        image: product.image || items[existingIndex].image || '',
        price: product.price || items[existingIndex].price || '',
        comparePrice:
          product.comparePrice ||
          items[existingIndex].comparePrice ||
          '',
        addedAt:
          items[existingIndex].addedAt ||
          product.addedAt ||
          Date.now()
      };
    }

    writeWishlist(items);
  }

  function remove(handle){

    var items = readWishlist().filter(function(item){
      return item.handle !== handle;
    });

    writeWishlist(items);
  }

  function refreshButtons(){

    var items = readWishlist();

    var handles = items.map(function(item){
      return item.handle;
    });

    document
      .querySelectorAll('[data-cmr-wishlist]')
      .forEach(function(button){

        var handle =
          button.getAttribute('data-product-handle');

        var active =
          handles.indexOf(handle) !== -1;

        button.classList.toggle('is-active', active);

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

        button.setAttribute(
          'aria-label',
          active
            ? t(
                'Retirer des favoris',
                'Remove from favourites'
              )
            : t(
                'Ajouter aux favoris',
                'Add to favourites'
              )
        );
      });

    document
      .querySelectorAll('[data-cmr-wishlist-count]')
      .forEach(function(counter){

        counter.textContent = items.length;
        counter.hidden = items.length === 0;

      });
  }

  function ensureToast(){

    var toast =
      document.getElementById('cmr-wishlist-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cmr-wishlist-toast';
      document.body.appendChild(toast);
    }

    toast.className = 'cmr-wishlist-toast';

    toast.innerHTML =
      '<div class="cmr-wishlist-toast__thumb">' +
        '<span>♡</span>' +
      '</div>' +
      '<div class="cmr-wishlist-toast__content">' +
        '<div class="cmr-wishlist-toast__title"></div>' +
        '<div class="cmr-wishlist-toast__text"></div>' +
      '</div>';

    return toast;
  }

  function showToast(type, product){

    var toast = ensureToast();

    var thumb =
      toast.querySelector(
        '.cmr-wishlist-toast__thumb'
      );

    var title =
      toast.querySelector(
        '.cmr-wishlist-toast__title'
      );

    var text =
      toast.querySelector(
        '.cmr-wishlist-toast__text'
      );

    if (product && product.image) {

      thumb.innerHTML =
        '<img src="' +
        product.image +
        '" alt="' +
        (product.title || t('Produit', 'Product')) +
        '">';

    } else {

      thumb.innerHTML = '<span>♡</span>';

    }

    if (type === 'add') {

      toast.classList.add('is-add');
      toast.classList.remove('is-remove');

      title.textContent = t(
        'Ajouté aux coups de cœur',
        'Added to favourites'
      );

      text.textContent = t(
        'Votre sélection est bien enregistrée.',
        'Your selection has been saved.'
      );

    } else {

      toast.classList.add('is-remove');
      toast.classList.remove('is-add');

      title.textContent = t(
        'Retiré des coups de cœur',
        'Removed from favourites'
      );

      text.textContent = t(
        'Le produit a été supprimé de vos coups de cœur.',
        'The product has been removed from your favourites.'
      );
    }

    clearTimeout(toastTimer);

    toast.classList.add('is-visible');

    toastTimer = setTimeout(function(){
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function toggle(button){

    var product = getProduct(button);
    if (!product) return;

    var action = 'add';

    if (exists(product.handle)) {

      remove(product.handle);
      action = 'remove';

    } else {

      add(product);
      action = 'add';

    }

    refreshButtons();

    showToast(action, product);

    document.dispatchEvent(
      new CustomEvent(
        'cmr:wishlist-updated',
        {
          detail: {
            items: readWishlist(),
            action: action,
            product: product
          }
        }
      )
    );
  }

  document.addEventListener(
    'click',
    function(event){

      var button =
        event.target.closest(
          '[data-cmr-wishlist]'
        );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      toggle(button);

    },
    true
  );

  document.addEventListener(
    'keydown',
    function(event){

      var button =
        event.target.closest(
          '[data-cmr-wishlist]'
        );

      if (!button) return;

      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      toggle(button);

    },
    true
  );

  document.addEventListener(
    'DOMContentLoaded',
    refreshButtons
  );

  window.addEventListener(
    'load',
    refreshButtons
  );

  document.addEventListener(
    'shopify:section:load',
    function(){
      setTimeout(refreshButtons, 50);
    }
  );

  document.addEventListener(
    'cmr:product-switched',
    function(){
      setTimeout(refreshButtons, 80);
    }
  );

  window.addEventListener(
    'storage',
    function(event){

      if (event.key === STORAGE_KEY) {
        refreshButtons();
      }

    }
  );

  window.CMRWishlist = {
    read: readWishlist,
    refresh: refreshButtons,
    add: add,
    remove: remove
  };

  window.CMRWishlistToast = {
    show: showToast
  };

})();